import quarkusApi from '../../../api/quarkusApi';

export function useSaveUser() {
  const save = (user) => {
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    return user.id
      ? quarkusApi.put(
          `/configuration/clinic-users/${user.id}`,
          { name: user.name, roles: user.roles },
          authHeader,
        )
      : quarkusApi.post(
          '/configuration/clinic-users',
          { name: user.name, login: user.login, roles: user.roles },
          authHeader,
        );
  };

  return { save };
}
